/*
 * @Author: Michael
 * @Date: 2018-01-05 13:39:43
 * @Last Modified by: Michael
 * @Last Modified time: 2019-08-29 15:00:31
 */
export default {
  routes: [{
    path: '/comment/teacher',
    name: 'comment_teacher',
    component: () => import('@/module/comment/CommentTeacherPage.vue'),
    meta: {
      title: '评价老师',
      keepAlive: false,
      logined: true
    }
  },

  {
    path: '/comment',
    name: 'comment_received',
    component: () => import('@/module/comment/CommentReceivedPage.vue'),
    meta: {
      title: '课后评价',
      keepAlive: true,
      logined: true
    }
  },
  {
    path: '/comment/detail',
    name: 'comment_detail',
    component: () => import('@/module/comment/CommentDetailPage.vue'),
    meta: {
      title: '评价详情',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/comment/detail/edit',
    name: 'comment_detail_edit',
    component: () => import('@/module/comment/CommentDetailEditPage.vue'),
    meta: {
      title: '评价评论',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/rating/teacher/edit',
    name: 'rating_teacher_edit',
    component: () => import('@/module/comment/RatingTeacherEditPage.vue'),
    meta: {
      title: '评价',
      keepAlive: false,
      logined: true
    }
  },
  {
    path: '/rating/teacher/detail',
    name: 'rating_teacher_detail',
    component: () => import('@/module/comment/RatingTeacherDetailPage.vue'),
    meta: {
      title: '评价',
      keepAlive: false,
      logined: true
    }
  },
  ]
}



// WEBPACK FOOTER //
// ./src/router/Comment.js